<!--AFFICHAGE BLOC Contexte Client -->
<template>
  <v-col md="12" v-if="!this.$store.state.userLea || getEnv() == 'DAAS'">
    <!-- CONTEXTE CLIENT SIREN -->
    <v-col
      md="12"
      class="pa-3 d-flex flex-column"
      v-if="this.condition_siren()"
    >
      <a class="anchor" id="bloc-contexte-clients-siren"></a>

      <v-card elevation="2">
        <v-card-title>
          <v-icon dense left color="indigo darken-2"> person </v-icon> Contexte
          Client Entreprise
          <v-rating
            v-if="this.ctx.etoiles_siren != null"
            v-model="this.ctx.etoiles_siren"
            half-increments
            length="5"
            density="compact"
            readonly
          ></v-rating>
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-if="this.ctx_clients_siren != null"
            dense
            :headers="headers"
            :items="ctx_clients_siren"
            item-key="ctx-clients-siren"
            class="elevation-1"
            group-by="num_client"
            ref="tableSiren"
            :sort-by="['active', 'date_effet']"
            :sort-desc="[false, true]"
          >
            <template v-slot:group.header="{ items, isOpen, toggle }">
              <th colspan="9">
                <v-icon @click="toggle" :data-open="isOpen">{{
                  isOpen ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ items[0].statut_libelle }} - {{ items[0].num_client }} -
                {{ items[0].raison_social }} - {{ items[0].adresse[0] }} -
                Réseau {{ items[0].reseau }}
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="intermediaire"
                      :color="
                        items[0].intermediaire.surveillance.length > 0
                          ? 'red'
                          : 'green'
                      "
                      v-bind="attrs"
                      v-on="on"
                      style="border-radius:100px; color:white; height:22px; margin-top:2px; margin-bottom:2px;"
                      >{{ items[0].code_intermediaire }}
                    </v-btn></template
                  >
                  <v-list>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Nom Intermediaire</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.nom_intermediaire
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Nom representant</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.nom_representant
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Nom Inspecteur</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.nom_inspecteur
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Unite Regionale</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.unite_regionale
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Surveillance</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.surveillance.length > 0
                            ? "Oui"
                            : "Non"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                - {{ items[0].detention }} contrat(s)
                <v-rating
                  v-if="items[0].etoile != undefined"
                  v-model="items[0].etoile"
                  half-increments
                  length="5"
                  size="x-small"
                  density="compact"
                  readonly
                  style="display: inline-block;"
                ></v-rating>
              </th>
            </template>
            <template
              v-for="header in headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
            <template v-slot:item.active="{ item }">
              <v-chip
                :color="getColor(item.active)"
                variant="outlined"
                label
                class="ma-2"
                size="x-small"
                dark
              >
                {{ item.active }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      md="12"
      class="pa-3 d-flex flex-column"
      v-if="this.condition_siret()"
    >
      <a class="anchor" id="bloc-contexte-clients-siret"></a>

      <v-card elevation="2">
        <v-card-title>
          <v-icon dense left color="indigo darken-2"> person </v-icon> Contexte
          Client Etablissement
          <v-rating
            v-if="this.ctx.etoiles_siret != null"
            v-model="this.ctx.etoiles_siret"
            half-increments
            length="5"
            density="compact"
            readonly
          ></v-rating>
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-if="this.ctx_clients_siret != null"
            dense
            :headers="headers"
            :items="ctx_clients_siret"
            item-key="ctx-clients-siret"
            class="elevation-1"
            group-by="num_client"
            :sort-by="['active', 'date_effet']"
            :sort-desc="[false, true]"
            multi-sort
          >
            <template v-slot:group.header="{ items, isOpen, toggle }">
              <th colspan="9">
                <v-icon @click="toggle">{{
                  isOpen ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ items[0].statut_libelle }} - {{ items[0].num_client }} -
                {{ items[0].raison_social }} - {{ items[0].adresse[0] }} -
                Réseau {{ items[0].reseau }}
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="intermediaire"
                      :color="
                        items[0].intermediaire.surveillance.length > 0
                          ? 'red'
                          : 'green'
                      "
                      v-bind="attrs"
                      v-on="on"
                      style="border-radius: 100px; color: white; height:22px; margin-top: 2px; margin-bottom: 2px;"
                      >{{ items[0].code_intermediaire }}
                    </v-btn></template
                  >
                  <v-list>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Nom Intermediaire</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.nom_intermediaire
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Nom representant</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.nom_representant
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Nom Inspecteur</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.nom_inspecteur
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Unite Regionale</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.unite_regionale
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Surveillance</v-list-item-title>
                        <v-list-item-subtitle>{{
                          items[0].intermediaire.surveillance.length > 0
                            ? "Oui"
                            : "Non"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                - {{ items[0].detention }} contrat(s)
                <v-rating
                  v-if="items[0].etoile != undefined"
                  v-model="items[0].etoile"
                  density="compact"
                  half-increments
                  length="5"
                  size="x-small"
                  readonly
                  style="display: inline-block;"
                ></v-rating>
              </th>
            </template>
            <template
              v-for="header in headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
            <template v-slot:item.active="{ item }">
              <v-chip
                :color="getColor(item.active)"
                variant="outlined"
                label
                class="ma-2"
                size="x-small"
              >
                {{ item.active }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
export default {
  name: "ContextClients",
  props: ["etablissement"],
  components: {},

  computed: {
    is_prospect: function () {
      var ctx_clients = this.$store.getters.getbloc(
        "environnement",
        "donnees",
        "contexte_client",
        null,
        "valeur"
      );
      if (ctx_clients === null || ctx_clients === undefined) {
        return false;
      } else {
        return ctx_clients.statut_client === "Prospect";
      }
    },
    ctx_clients_siren: function () {
      var ctx_clients_siren = this.$store.getters.getbloc(
        "environnement",
        "donnees",
        "contexte_client_siren",
        null,
        "valeur"
      );
      if (ctx_clients_siren === null || ctx_clients_siren === undefined) {
        return null;
      } else {
        var client_contrat_siren = [];
        console.log(ctx_clients_siren);
        ctx_clients_siren.forEach((client) => {
          client.contrats.forEach((contrat) => {
            client_contrat_siren.push({
              "active": contrat.active ? "Actif": "Inactif",
              "reseau" : client.reseau,
              "detention" : client.detention,
              "raison_social" : client.raison_social,
              "num_client": client.num_client,
              "etoile" : client.etoiles,
              "type_personne": client.type_personne,
              "nature_personne": client.nature_personne,
              "statut_libelle" : client.statut_libelle,
              "adresse": client.adresse,
              "code_intermediaire": client.code_intermediaire,
              "intermediaire": client.intermediaire,
              "num_contrat": contrat.num_contrat,
              "prime": contrat.prime,
              "famille_cible": contrat.famille_cible,
              "date_effet": contrat.date_effet,
              "searchlink":this.search(client.raison_social+" "+client.adresse )
            })
          })
        })
        return client_contrat_siren;
      }
    },

    ctx_clients_siret: function () {
      var ctx_clients_siret = this.$store.getters.getbloc(
        "environnement",
        "donnees",
        "contexte_client_siret",
        null,
        "valeur"
      );
      if (ctx_clients_siret === null || ctx_clients_siret === undefined) {
        return null;
      } else {
        var client_contrat_siret = [];
        ctx_clients_siret.forEach((client) => {
          client.contrats.forEach((contrat) => {
            client_contrat_siret.push({
              "active": contrat.active ? "Actif": "Inactif",
              "num_client": client.num_client,
              "reseau" : client.reseau,
              "detention" : client.detention,
              "raison_social" : client.raison_social,
              "type_personne": client.type_personne,
              "nature_personne": client.nature_personne,
              "etoile" : client.etoiles,
              "statut_libelle" : client.statut_libelle,
              "adresse": client.adresse,
              "code_intermediaire": client.code_intermediaire,
              "intermediaire": client.intermediaire,
              "num_contrat": contrat.num_contrat,
              "prime": contrat.prime,
              "famille_cible": contrat.famille_cible,
              "date_effet": contrat.date_effet,
               "searchlink":this.search(client.raison_social+" "+client.adresse )
            })
          })
        })
        return client_contrat_siret;
      }
    },
    ctx: function () {
      var ctx = this.$store.getters.getbloc(
        "environnement",
        "donnees",
        "contexte_client",
        null,
        "valeur"
      );
      if (ctx === null || ctx === undefined) {
        return null;
      } else {
        return ctx;
      }
    },
    headers() {
      return [
        { text: "Statut", value: "active", align: "center" },
        { text: "Num Contrat", value: "num_contrat", align: "start" },
        { text: "Num Client", value: "num_client", align: "start" },
        { text: "Type personne", value: "type_personne", align: "start" },
        { text: "Nature personne", value: "nature_personne", align: "start" },
        //{ text: "Code Intermédiaire", value: "code_intermediaire", align: "start" },
        // { text: "Adresse", value: "adresse", align: "start" },
        { text: "Date_effet", value: "date_effet", align: "start" },
        { text: "Famille Cible", value: "famille_cible", align: "start" },
        { text: "Prime", value: "prime", align: "start" },
      ];
    },
  },
  data() {
    return {
      overlay: false,
    };
  },
  methods: {
    searchByNameAdresse(name_adresse) {
        this.$store.dispatch('findSiretFor',name_adresse)
    },
    getColor(active) {
      if (active == "Actif") return "green";
      else return "grey";
    },
    getEnv() {
      return process.env.VUE_APP_ENV;
    },
    displaySelected(siret) {
      this.$store.dispatch("getEtablissement", siret);
    },
    condition_siret() {
      return (
        this.$store.getters.condition(
          "environnement",
          "donnees",
          "contexte_client_siret",
          "valeur"
        ) ||
        this.$store.getters.condition(
          "environnement",
          "donnees",
          "contexte_client_siret",
          "valeur"
        )
      );
    },
    condition_siren() {
      return (
        this.$store.getters.condition(
          "environnement",
          "donnees",
          "contexte_client_siren",
          "valeur"
        ) ||
        this.$store.getters.condition(
          "environnement",
          "donnees",
          "contexte_client_siret",
          "valeur"
        )
      );
    },
     search : function (data) {
      return  window.location.origin + '/search/' + encodeURIComponent(data);

    },
  },
};
</script>


